import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useOpenWindow from '@swf/core/hooks/useOpenWindow';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import ButtonGroup from '../../../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../../../CTAButton/CTAButton';
import TransitionalExitPrompt from '../../../../../TransitionalExitPrompt/TransitionalExitPrompt';

import {
  TXTWCL_Back_to_Cashier,
  TXTWCL_For_more_information_please_cl_ELL,
  TXTWCL_Generate_barcode_1,
  TXTWCL_The_PayNearMe_website_will_ope_ELL
} from './PayNearMeRedirect.messages.json';

type Props = DepositResult &
  DepositContext & {
    showPrompt?: boolean;
  };

const PayNearMeRedirect: React.FC<Props> = ({ showPrompt, redirectUrl }) => {
  const openWindow = useOpenWindow({
    targetUrl: redirectUrl.url,
    centered: true
  });

  return (
    <div>
      <Translation {...TXTWCL_The_PayNearMe_website_will_ope_ELL} />
      <Translation
        tagName="p"
        {...TXTWCL_For_more_information_please_cl_ELL}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.RealMoneyPayNearMe}>{msg}</ResolverLink>
          )
        }}
      />
      <ButtonGroup>
        <CTAButton type="button" translation={TXTWCL_Generate_barcode_1} onClick={openWindow} />
        <CTAButton
          alias="firstWalletHome"
          variant="secondary"
          translation={TXTWCL_Back_to_Cashier}
        />
      </ButtonGroup>

      {showPrompt && <TransitionalExitPrompt />}
    </div>
  );
};

export default PayNearMeRedirect;
